import React from 'react';
import { useProctor } from '../../context/ProctorContext';

export function RightPanel() {
  const { config, sensorValues } = useProctor();

  const gazeZ = sensorValues.gaze.zScore;
  const keyZ = sensorValues.keyboard.zScore;
  const voiceSDR = parseFloat(sensorValues.voice.value) || 0;
  const styZ = sensorValues.stylus.zScore;

  const anomalyChannels: string[] = [];
  if (Math.abs(gazeZ) >= config.zThresh) anomalyChannels.push('헤드포즈');
  if (Math.abs(keyZ) >= config.zThresh) anomalyChannels.push('키보드');
  if (voiceSDR >= config.voicePct) anomalyChannels.push('음성');
  if (Math.abs(styZ) >= config.zThresh) anomalyChannels.push('스타일러스');

  const fusionMet = anomalyChannels.length >= config.minChannels;

  return (
    <div className="right-panel">
      <div className="rule-section">
        <h3>분석 로직 (Rule Engine)</h3>
        <div className="rule-box">
          <div className="rc-title">컨텍스트 트리 — {config.label}</div>
          <div className="rc-row"><span className="rc-key">Z-score 임계치</span><span className="rc-val">{config.zThresh}</span></div>
          <div className="rc-row"><span className="rc-key">지속 시간</span><span className="rc-val">{config.sustainSec}초</span></div>
          <div className="rc-row"><span className="rc-key">최소 교차 채널</span><span className="rc-val">{config.minChannels}개</span></div>
          <div className="rc-row"><span className="rc-key">인접 윈도우</span><span className="rc-val">{config.adjacentSec}초</span></div>
          <div className="rc-row"><span className="rc-key">음성 SDR 임계치</span><span className="rc-val">{config.voicePct}%</span></div>
        </div>
      </div>

      <div className="rule-section">
        <div className="rule-box">
          <div className="rc-title">실시간 채널 Z-score</div>
          <ZRow label="헤드포즈 (Yaw)" z={gazeZ} thresh={config.zThresh} />
          <ZRow label="키보드" z={keyZ} thresh={config.zThresh} />
          <div className="rc-row">
            <span className="rc-key">음성 SDR</span>
            <span className="rc-val" style={{ color: voiceSDR >= config.voicePct ? 'var(--red)' : 'var(--text)' }}>
              {voiceSDR.toFixed(1)}%
            </span>
          </div>
          <ZRow label="스타일러스" z={styZ} thresh={config.zThresh} />
        </div>
      </div>

      <div className="rule-section">
        <div className="rule-box">
          <div className="rc-title">멀티채널 교차검증 (Fusion)</div>
          <div className="rc-row">
            <span className="rc-key">이상 채널</span>
            <span className="rc-val" style={{ color: anomalyChannels.length >= 2 ? 'var(--red)' : anomalyChannels.length === 1 ? 'var(--yellow)' : 'var(--text)' }}>
              {anomalyChannels.length}개{anomalyChannels.length > 0 ? ` (${anomalyChannels.join(', ')})` : ''}
            </span>
          </div>
          <div className="rc-row">
            <span className="rc-key">교차검증</span>
            <span className="rc-val" style={{ color: fusionMet ? 'var(--red)' : anomalyChannels.length === 1 ? 'var(--yellow)' : 'var(--green)' }}>
              {fusionMet ? `충족 (${anomalyChannels.length}채널)` : anomalyChannels.length === 1 ? '단일채널 (증거 부족)' : '미충족'}
            </span>
          </div>
          <div className="rc-row"><span className="rc-key">매칭 시나리오</span><span className="rc-val">—</span></div>
        </div>
      </div>
    </div>
  );
}

function ZRow({ label, z, thresh }: { label: string; z: number; thresh: number }) {
  const absZ = Math.abs(z);
  const color = absZ >= thresh ? 'var(--red)' : absZ >= thresh * 0.7 ? 'var(--yellow)' : 'var(--text)';
  return (
    <div className="rc-row">
      <span className="rc-key">{label}</span>
      <span className="rc-val" style={{ color }}>{z.toFixed(2)}</span>
    </div>
  );
}
